export default __webpack_public_path__ + "static/media/digiSuccess@2x.d3c6ed8c.png";